/* eslint-disable */
import {useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {message as antMessage} from "antd";
import {checkIsJSON} from "./DoctaChatBox";
import {baseURL} from "../../api/Request";

import MyContext from "./Mycontext";
import eventBus from "../../eventBus";





interface messageType {
	userId: string | number;
	message: string | number | null;
	taskType: string;
	conversationId: string | number;
	taskData1: string;
	taskData2: string;
	taskData3: string;
}

interface SseContextType {
	message: string;
	sendMessage: (message: messageType) => void;
	reconnect: () => void;
	save?: boolean;
	streamMessages: string[];
}


export function useSse(
	setSave: (value: boolean) => void,
	setIsLoading?: (value: boolean) => void
): SseContextType{

	const [streamMessages, setStreamMessages] = useState<string[]>([]);
	const navigate = useNavigate();
	const [message, setMessage] = useState<string>('');




	const sendMessage = async (message: messageType) => {
		// const response = await fetch(`http://localhost:8080/news/conversation`, {
		if (setIsLoading) {
			setIsLoading(true);
		}
		const response = await fetch(`${baseURL}/api/v1/connect`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${localStorage.getItem("token")}`,
			},
			body: JSON.stringify(message)
		});
		if (!response.body) {
			throw new Error("No response body");
		}

		const reader = response.body.getReader();
		const decoder = new TextDecoder("utf-8");
		let buffer = "";

		while (true) {
			let done;
			let value;
			try {
				const result = await reader.read();
				done = result.done;
				value = result.value;
			}catch (e) {
				antMessage.error("网络错误，请稍后并刷新");
				break;
			}

			if (done) {
				console.log("done");
				break;
			}

			buffer += decoder.decode(value, {stream: true});

			// 逐行解析流（以换行符为分隔符）
			const lines = buffer.split("\n");
			buffer = lines.pop() || ""; // 最后一行可能是不完整的，留着下次继续解析

			for (const line of lines) {
				console.log("sse line: ", line);
				if (line.startsWith("event:")){

				} else if (line.startsWith("data:")){
					const rawData = line.replace(/^data:/, "").trim();
					if (checkIsJSON(rawData)) {
						const parsedData = JSON.parse(rawData);

						if (parsedData?.message === "会话信息不匹配，请重新登录") {
							sessionStorage.removeItem("sessionId");
							localStorage.clear();
							navigate("/");
						} else if (parsedData?.message === "模型服务故障") {
							antMessage.error("模型服务故障");
						}

						if (checkIsJSON(parsedData?.message)) {
							const parsedMessage = JSON.parse(parsedData?.message);

							if (
								Array.isArray(parsedMessage) &&
								checkIsJSON(parsedMessage[0]) &&
								JSON.parse(parsedMessage[0])?.error
							) {
								antMessage.error(JSON.parse(parsedMessage[0]).error);
							} else {
								setStreamMessages(parsedMessage);
								console.log("streamMessage", parsedMessage);
								setSave(parsedData.isSave);
								if (setIsLoading) {
									setIsLoading(!parsedData.isSave)
								}
							}
						} else {
							if (setIsLoading) {
								setIsLoading(!parsedData.isSave)
							}
							setSave(parsedData?.isSave);
						}
					}else {
						setMessage(rawData);
						setSave(true);
					}
				}

			}
		}
	};

	const reconnect = () => {
	};

	return {message, sendMessage, reconnect, streamMessages};
}
